import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import BgmiFooter from './BgmiFooter';

export default function ProtocolPage({ title, content }) {
    useEffect(() => {
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, []);

    const handleBack = () => {
        window.location.hash = '#';
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="w-full min-h-screen bg-transparent dark:bg-[#0a0a0f] font-['Monda'] text-gray-900 dark:text-white flex flex-col"
        >
            <div className="max-w-[120rem] mx-auto px-[15px] pt-[15px] pb-[15px] w-full">
                {/* Header */}
                <div className="flex items-center justify-between border-b border-gray-200 dark:border-white/10 pb-[15px] mb-[15px]">
                    <div>
                        <button onClick={handleBack} className="text-gray-500 dark:text-gray-400 hover:text-pink-600 dark:hover:text-pink-500 mb-4 flex items-center gap-2 transition-colors">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                            Back to Lobby
                        </button>
                        <h2 className="text-3xl md:text-5xl font-black tracking-wider text-gray-900 dark:text-white uppercase">{title}</h2>
                    </div>
                </div>

                {/* Content */}
                <div className="bg-white/80 dark:bg-[#1a1a24]/80 backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-lg p-[15px] sm:p-8 shadow-sm dark:shadow-none flex-1">
                    <div className="prose prose-pink dark:prose-invert max-w-none prose-headings:font-black prose-headings:tracking-wider prose-headings:uppercase prose-p:text-gray-600 dark:prose-p:text-gray-400 prose-p:font-semibold prose-a:text-pink-500 hover:prose-a:text-pink-600 transition-colors">
                        {content}
                    </div>
                </div>
            </div>
            <BgmiFooter className="mt-0" />
        </motion.div>
    );
}
